import { t } from '@repo/i18n';
import { useLocale } from '@repo/i18n/react';
import { Button } from '@repo/ui/button';
import { Building2, X } from 'lucide-react';
import { Activity } from 'react';

interface OrganizationsTableEmptyStateProps {
  searchQuery: string;
  onClearFilters: () => void;
  hasFilters: boolean;
}

export function OrganizationsTableEmptyState({
  searchQuery,
  onClearFilters,
  hasFilters,
}: OrganizationsTableEmptyStateProps) {
  useLocale();

  return (
    <div className="flex flex-col items-center justify-center py-12 text-center">
      <Building2 className="mb-4 h-12 w-12 text-muted-foreground" />
      <h3 className="mb-2 font-semibold text-lg">{t('workspace.noOrganizationsFound')}</h3>
      <p className="text-muted-foreground">
        {searchQuery
          ? t('workspace.noOrganizationsMatchYourSearchCriteria')
          : t('workspace.thereAreNoOrganizationsInTheSystemYet')}
      </p>
      <Activity mode={hasFilters ? 'visible' : 'hidden'}>
        <Button className="mt-4 bg-background" onClick={onClearFilters} variant="outline">
          <X className="h-4 w-4" />
          {t('workspace.clearFilters')}{' '}
        </Button>
      </Activity>
    </div>
  );
}
